export function Footer() {
	return (
		<footer className="border-t border-border-subtle py-6">
			<div className="mx-auto max-w-7xl px-4 lg:px-8">
				<p className="text-center text-sm text-muted">
					&copy; {new Date().getFullYear()} Telemetry Drops. All rights reserved.
				</p>
			</div>
		</footer>
	);
}
